import React, { useState, useEffect } from "react";
import "./Newlp.css";
import { useSelector, useDispatch, connect } from "react-redux";
import { useLocation, useHistory } from "react-router";
import { BsPaperclip } from "react-icons/bs";
import { FaUserCircle, FaMapPin, FaWhatsappSquare } from "react-icons/fa";
import { RiWhatsappFill } from "react-icons/ri";
//IMPORTING ACTIONS FOR REEDUX API CALL
import { getCity, uploadLp, getCall } from "../../Redux/Actions";
import { Modal } from "react-responsive-modal";
import PatientActions from "../../components/Cart/PatientDetailsAction"
import Axios from "../../config/Axios";
import Meta from "../../components/Meta";
const LpForm = (props) => {
  const {
    lpThyroid,
    focusInput,
    position,
    butname,
    title,
    formId,
    isLp,
    isImagine,
    lpNumber,
    upload,
    focus,
    push,
    buttonId,
    autoFill,
  } = props;
  const [userName, setUserName] = useState("");
  const [number, setNumber] = useState("");
  const [userNumber, setUserNumber] = useState("");
  const [userCity, setUserCity] = useState("");
  const [nameError, setNameEror] = useState("");
  const [phoneError, setPhoneEror] = useState("");
  const [displayCityList, setDisplay] = useState(true);
  const [success, setSucess] = useState(false);
  const [checkboxState, setCheckboxState] = useState(true);
  const [disable, setDisable] = useState(true);
  const [openSuccModel, setSucc] = useState(false);

  const history = useHistory();

  const [previewName, setPreview] = useState(
    "Upload a Prescription (optional)"
  );
  const [previewError, setFileError] = useState("");
  const [filename, setFilename] = useState("");
  const [fileSelected, setFileSelected] = useState();
  // console.log("lp number", lpNumber, fileSelected);
  useEffect(() => {
    if (isImagine) {
      setNumber("898 898 0101");
    } else if (isLp || lpNumber) {
      setNumber(lpNumber);
    } else {
      setNumber("898 898 8787");
    }
  }, [isImagine, isLp]);
  //cont
  const openSucess = () => setSucc(true);
  const closeSuccess = () => setSucc(false);

  useEffect(() => {
    if (
      userName == "" ||
      userCity == "" ||
      userNumber == "" ||
      userNumber.length !== 12
    ) {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [userName, userCity, userNumber]);
  //calling city name api
  useEffect(() => {
    dispatch(getCity());
  }, []);

  //comment
  //GETTING DATA FROM STORE (CITIES NAME) STARTS HERE
  const navCity = useSelector((state) => state.navCityList);
  const { navCities } = navCity;
  const citiesFromArray = navCities;
  const cityList = useSelector((state) => state.cityList);
  const { cities, loading } = cityList;

  const dispatch = useDispatch();

  //   const handelCityChange = (e) => {
  //     document.getElementById("cityList").classList.remove("displayNone");

  //     userCity(e.target.value);
  //   };
  //use location imported
  const location = useLocation();
  ///${position}
  console.log("location>>",location)
 

  var url = `https://redcliffelabs.com${location.pathname}/${position ? position : ""}/${location.search}`;

  //var url = `https://redcliffelabs.com${location.pathname}/${position}`;

  //HANDEL USERNAME FUNCTON BELOW THIS COMMENT
  const handelUserName = (e) => {
    setUserName(e.target.value);
    const characterRegex = /^([A-Za-z]+[ ]?)+$/;
    setNameEror("");
    if (!e.target.value.match(characterRegex)) {
      setNameEror("invalid user name");
    }
    if (e.target.value == "") {
      setNameEror("");
    }
  };

  //handel new phone validation
  const normalizeInput = (value, previousValue) => {
    // return nothing if no value
    if (!value) return value;

    // only allows 0-9 inputs
    const currentValue = value.replace(/[^\d]/g, "");
    const cvLength = currentValue.length;

    if (!previousValue || value.length > previousValue.length) {
      // returns: "x", "xx", "xxx"
      if (cvLength < 4) return currentValue;

      // returns: "(xxx)", "(xxx) x", "(xxx) xx", "(xxx) xxx",
      if (cvLength < 7)
        return `${currentValue.slice(0, 3)}-${currentValue.slice(3)}`;

      // returns: "(xxx) xxx-", (xxx) xxx-x", "(xxx) xxx-xx", "(xxx) xxx-xxx", "(xxx) xxx-xxxx"
      return `${currentValue.slice(0, 3)}-${currentValue.slice(
        3,
        6
      )}-${currentValue.slice(6, 10)}`;
    }
  };
  //changefilein base 64 string
  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  const handelfile = (e) => {
    // console.log("filename ", e.target?.files[0]?.name);
    setFileSelected(e.target?.files[0]);

    var myTruncatedString =
      e.target?.files[0]?.name?.substring(0, 10) + e.target?.files[0]?.type;

    setPreview(myTruncatedString);

    const filePath = e.target.value;
    var allowedExtensions = /(\.png|\.pdf|\.jpg|\.jpeg)$/i;

    if (e.target?.files[0]?.size > 5000000) {
      setFileError("File size should be less then 5 MB");
    } else if (allowedExtensions.exec(filePath)) {
      setPreview(e.target.files[0].name);

      var myTruncatedString =
        e.target?.files[0]?.name.substring(0, 10) +
        "." +
        e.target?.files[0]?.type;

      setPreview(myTruncatedString);

      setFileError("");
      var file = e.target?.files[0];
      getBase64(file).then((data) => {
        setFilename(data);
        // console.log(data);
      });
    } else {
      setFilename("");
      // console.log("inside else", e.target?.files[0]);
      setFileError("invalid file type");
    }
    e.target.value = "";
  };
  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 2
  const validatePhoneNumber = () => {
    let phoneno = /[^\d]/g;
    if (
      !userNumber.match(phoneno) ||
      parseInt(userNumber[0]) < 6 ||
      userNumber.length < 12
    ) {
      if (userNumber === "") {
        return false;
      } else {
        setPhoneEror("Enter a valid number");
        return false;
      }
    } else {
      return true;
    }
  };

  const handleCheckChange = (e) => {
    setCheckboxState(!checkboxState);
  };

  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 1
  const handelPhoneChange = (e, userNumber) => {
    setUserNumber(normalizeInput(e.target.value, userNumber));
    setPhoneEror("");
  };

  const handelSubmit = (e) => {
    e.preventDefault();
    const checkVal = validatePhoneNumber();

    if (checkVal) {
      let formData = new FormData();
      formData.append("name", userName);
      formData.append("mobile", userNumber.replaceAll("-", ""));
      formData.append("source", "google_lp");
      formData.append("address", userCity);
      formData.append("city", userCity);
      formData.append("url", url);
      if (fileSelected) {
        formData.append("image", fileSelected);
      }

      const body = {
        optin: checkboxState,
        name: userName,
        phone_no: userNumber.replaceAll("-", ""),
        source: "Ecommerce",
        city: userCity,
        url,
      };
      console.log(body);
      setUserNumber("");
      setUserName("");
      setUserCity("");
      setPreview("Upload a Prescription (opt.)");
      setSucess(true);
      openSucess(true);
      setTimeout(() => {
        setSucess(false);
      }, 2000);
      if (upload) {
        props.leadGenrated(formData);
      } else {
        props.getCall(body);
      }
      // if (push) {
      //   history.push({
      //     search: "?/ThankYou",
      //   });
      // }
    }
  };

  const setInputcity = (val) => {
    setUserCity(val);
    setDisplay(false);
  };

  const handelCityChange = (e) => {
    setUserCity(e.target.value);
    setDisplay(true);
  };

  useEffect(() => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal?.token;
    if (autoFill && token) {
      props?.getProfileDetails(token)
    }
  }, []);


  useEffect(() => {
    if (props?.userProfile?.username && props?.userProfile?.phonenumber) {
      setUserNumber(`${props?.userProfile?.phonenumber.slice(0, 3)}-${props?.userProfile?.phonenumber.slice(3, 6)}-${props?.userProfile?.phonenumber.slice(6, 10)}`);
      setUserName(props?.userProfile?.fullname)
    }
  }, [props?.userProfile]);




  //model div
  console.log(location.pathname, "location")
  const SuccessModel = ({ number }) => {
    return (
      <div className="SuccessMsg_upload">
        {location.pathname.includes("lp6/ABS01/vital-screening-package")||location.pathname.includes("lp6/ABS01/summer-special-package")?(
          <Meta>
          <script
            src="https://evt.paytm.com/pixel/frontend/pixel-1P.js?token=9875B8CCB68640C1"
            type="text/javascript"
          ></script>
        </Meta>
        ):""}
        <h2>
          We have received your information. We shall call you in few minutes to
          confirm the details. For any queries please call us at &nbsp;
          <a href={`tel:+91-${number}`} style={{ color: "blue" }}>
            {number}
          </a>{" "}
          - Team Redcliffe Labs
        </h2>
      </div>
    );
  };

  return (
    <form id={formId ? formId : "normalForm"} onSubmit={handelSubmit}>
      <div className="form__div">
        {/* <h4>Book Your Test</h4> */}
        <h4>{title ? title : "Book Your Test"}</h4>
        {upload || lpThyroid ? (
          <p style={{ fontSize: "1.7rem" }}>
            Select from our range of 3500+ tests
          </p>
        ) : null}
        <div>
          <div className="form__input numBox">
            <span className="userIcon">
              <FaUserCircle />
            </span>
            <div className="inputDiv">
              <input
                ref={focus}
                id="inputName"
                style={{ border: "none" }}
                onClick={() => focusInput && focusInput(false)}
                onBlur={() => focusInput && focusInput(true)}
                type="text"
                placeholder="Enter Name"
                onChange={handelUserName}
                value={userName}
              />
            </div>
          </div>
          <span className="FormError">{nameError}</span>
        </div>

        {/* <div className="phone_number">
                    +91 */}
        <div>
          <div className="form__input numBox">
            <span className="numIcon">+91</span>
            <div className="inputDiv">
              <input
                style={{ border: "none" }}
                onClick={() => focusInput && focusInput(false)}
                onBlur={() => {
                  validatePhoneNumber(), focusInput && focusInput(true);
                }}
                type="text"
                placeholder="Enter Phone Number"
                required
                onChange={handelPhoneChange}
                value={userNumber}
              />
            </div>
          </div>
          <span className="FormError">{phoneError}</span>
        </div>

        {/* </div>   */}
        <div className="citySelect">
          <span className="locIcon">
            {" "}
            <FaMapPin />{" "}
          </span>

          <input
            // style={{ border: "none" }}
            className="appointCity"
            type="text"
            placeholder="Enter City"
            onClick={() => focusInput && focusInput(false)}
            onChange={handelCityChange}
            value={userCity}
          />

          {/* <AiFillCaretDown /> */}
          {/**CITY LIST ARRAY BELOW */}


        </div>


        {upload ? null : (
          <div className="LP_opt_Div">
            <input
              type="checkbox"
              onChange={() => handleCheckChange()}
              defaultChecked
              style={{ width: "22px", height: "22px" }}
            />
            <span className="watsap">
              <RiWhatsappFill className="wtsapIcon" />
            </span>
            <span className="textt">Opt-in for WhatsApp updates </span>

            {displayCityList ? (
              <div
                className={userCity ? "cityList citiesListNew citiesListNew1" : null}
                id="cityList"
              >
                {userCity !== "" && citiesFromArray && citiesFromArray.cities
                  ? citiesFromArray.cities
                    .filter((name) => {

                      if (userCity == "") {
                        return name;
                      } else if (
                        name.toLowerCase().includes(userCity.toLowerCase())
                      ) {
                        return name;
                      }
                    })
                    .map((values, index) => {
                      if (index < 2) {
                        return (
                          <>
                            <div
                              onClick={() => setInputcity(values)}
                              key={index}
                              className={
                                displayCityList ? "cityLIstLP" : "displayNone"
                              }
                            >
                              <span>{values}</span>
                            </div>
                          </>
                        );
                      }
                    })
                  : null}
              </div>
            ) : null}
          </div>
        )}
        {upload ? (
          <div style={{ marginTop: "2rem" }}>
            <div className="form__input numBox">
              <span className="userIcon">
                <BsPaperclip />
              </span>
              <div className="inputDiv">
                <label style={{ fontSize: "1.9rem", color: "gray" }}>
                  {previewName}
                  <input
                    type="file"
                    hidden
                    id="upload"
                    style={{ border: "none" }}
                    placeholder={previewName}
                    onChange={handelfile}
                  />
                </label>
              </div>
            </div>
            <span className="FormError">
              {" "}
              {previewError == "" ? null : previewError}
            </span>
          </div>
        ) : null}

        {/* <span className="successMsg">
          {
          success && isLp ? "success" : success ? "Your Form  has been submitted successfully!" : null}
          

          </span> */}


        <button
          id={buttonId ? buttonId : "normalButton"}
          type="submit"
          disabled={
            isLp
              ? nameError || disable
                ? "disabled"
                : ""
              : nameError
                ? "disabled"
                : ""
          }
          className={
            isLp
              ? nameError || disable
                ? "disabled"
                : ""
              : nameError
                ? "disabled"
                : ""
          }
        >

          {butname ? butname : "SUBMIT"}
        </button>
      </div>
      <Modal open={openSuccModel} onClose={closeSuccess} center>
        <SuccessModel number={number} />
      </Modal>
    </form>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state?.Profile?.profileDate,
});

const mapDispatchToProps = (dispatch) => {
  return {
    leadGenrated: (body) => {
      dispatch(uploadLp(body));
    },
    getCall: (body) => {
      dispatch(getCall(body));
    },
    getProfileDetails: (token) => {
      dispatch(PatientActions.getProfileDetails(token));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(LpForm));
